import type { RouteRecordRaw } from 'vue-router'

const healthRoutes: RouteRecordRaw[] = [
  {
    path: '/supervisor/health',
    name: 'HealthManagement',
    component: () => import('@/views/health/HealthManagementView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
  },
  {
    path: '/supervisor/health/events',
    name: 'HealthEvents',
    component: () => import('@/views/health/HealthEventsView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
  },
  {
    path: '/supervisor/health/vaccinations',
    name: 'Vaccinations',
    component: () => import('@/views/health/VaccinationsView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
  },
  {
    path: '/supervisor/health/quarantine',
    name: 'Quarantine',
    component: () => import('@/views/health/QuarantineView.vue'),
    meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
  },
]

export { healthRoutes }
